// extracted by mini-css-extract-plugin
module.exports = {"cardSetContainer":"style-module__cardSetContainer___wZ-3c","card":"style-module__card___oVwdM","logo":"style-module__logo___1tkwo"};